var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_40977",
    "data-name": "Group 40977",
    transform: "translate(22307 18243)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15554",
    "data-name": "Rectangle 15554",
    width: 16,
    height: 16,
    transform: "translate(-22307 -18243)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "clock",
    transform: "translate(-22308 -18244.68)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37031",
    "data-name": "Path 37031",
    d: "M5.2,5.207A6.342,6.342,0,0,0,4.219,6.47a6.23,6.23,0,0,0-.64,1.506L2.95,6.67a.5.5,0,0,0-.9.434L3.394,9.9a.512.512,0,0,0,.764.173L6.451,8.225a.5.5,0,0,0-.627-.779L4.481,8.526a5.252,5.252,0,0,1,.6-1.549,4.794,4.794,0,0,1,.511-.719c.1-.114.2-.233.31-.343a5.328,5.328,0,1,1,0,7.531,5.242,5.242,0,0,1-.881-1.168.5.5,0,0,0-.875.485A6.253,6.253,0,0,0,5.2,14.154a6.328,6.328,0,1,0,0-8.947Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37032",
    "data-name": "Path 37032",
    d: "M16.481,10.3a.5.5,0,0,0-.5.5v1.416a1.5,1.5,0,0,0,1.5,1.5H17.5l1.416-.014a.5.5,0,0,0,0-1h0l-1.416.014a.5.5,0,0,1-.505-.5V10.8a.5.5,0,0,0-.5-.5Z",
    transform: "translate(-6.991 -3.469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.d23fb113ddff6b7144c5b4d21d3ae2af.svg";
export { ForwardRef as ReactComponent };